// CARD SETS ICONS
import FintechSvg from "./svgs/Group 1000001123.svg";
import BlockChainSvg from "./svgs/Group 1000001124.svg";
import AiSvg from "./svgs/Group 1000001130.svg";
import VectorSvg from "./svgs/Vector.svg";
import GameSvg from "./svgs/Group 1000001131.svg";
import DronesSvg from "./svgs/Group 1000001133.svg";
import WebSvg from "./svgs/web app.svg";
import MobileSvg from "./svgs/mobile.svg";
import EdgeSvg from "./svgs/edge.svg";
import Embeded from "./svgs/embeded.svg";
import Cloud from "./svgs/cloud.svg";
import ScrapingSvg from "./svgs/scraping.svg"


// FAQS ICONS
import industrialIcon from './svgs/industrial.svg';
import healthcareIcon from './svgs/healthcare.svg';
import retailIcon from './svgs/retail.svg';
import agriculturalIcon from './svgs/agricultural.svg'


// LEVERAGES ICONS
import dApps from "./svgs/dapps.svg";
import fungible from "./svgs/fungible.svg";
import meta from "./svgs/meta.svg";
import token from "./svgs/token.svg";
import smart from "./svgs/smart.svg";
import custom from "./svgs/custom b.svg";
import exchange from "./svgs/exchange.svg";
import wallet from "./svgs/wallet.svg";


// INDUSTRIES ICONS
import estate from "./svgs/estate.svg";
import ecommerce from "./svgs/ecommerce.svg";
import health from "./svgs/healthcare.svg";
import  manufacturing from "./svgs/manufacturing.svg";
import media from "./svgs/media.svg";
import tourism from "./svgs/tourism.svg";
import education from "./svgs/education.svg";
import gaming from "./svgs/Group 1000001131.svg";



// XR SERVICE ICONS
import  vr from "./svgs/vr-glasses 1.svg";
import ar from "./svgs/augmented-reality 1.svg";
import model from "./svgs/modelling 1.svg";


// BLOGS IMAGE
import blog1 from "./images/blog 1.png";
import blog2 from "./images/blog 2.png";
import blog3 from "./images/blog 3.png";
import blog4 from "./images/blog 4.png";
import blog5 from "./images/blog 5.png";
import blog6 from "./images/blog 6.png";







// NAVBAR LINKS SECTION
export const links = [
    {
        name: "Home",
        path: '/'
    },
    {
        name: "Services",
        path: '/services'
    },
    {
        name: "Expertise",
        path: '/expertise'
    },
    {
        name: "Process",
        path: '/process'
    },
    {
        name: "About",
        path: '/about'
    },
    {
        name: "Blogs",
        path: '/blogs'
    },
    {
        name: "Projects",
        path: '/projects'
    }
]

// VALUES SECTION
export const values = [
    {
        id: 1,
        range: "99%",
        title: "Job Success based",
        desc: "on customer feedback"
    },
    {
        id: 2,
        range: "10 years+",
        title: "of experience in",
        desc: "software development"
    },
    {
        id: 3,
        range: "100+",
        title: "Expert Developers"
    },
    {
        id: 4,
        range: "Hundreds of",
        title: "Statisfied clients",
        desc: "around the world"
    }
]

// CARDS SET SECTION
export const cardSets = [
    [
      { title: "FINTECH/\nTRADING", image: FintechSvg },
      { title: "BLOCKCHAIN/\nCRYPTO", image: BlockChainSvg },
      { title: "AI/ML/\nDEEP LEARNING", image: AiSvg },
      { title: "INTERNET OF\nTHINGS", image: VectorSvg },
      { title: "AR/VR/\nGAME DEVELOPMENT", image: GameSvg },
      { title: "ROBOTICES/\nDRONES", image: DronesSvg },
    ],
    [
      { title: "WEB APPS", image: WebSvg },
      { title: "MOBILE APPS", image: MobileSvg },
      { title: "CLOUD\nCOMPUTING", image: Cloud },
      { title: "EDGE\nCOMPUTING ", image: EdgeSvg },
      { title: "EMBEDED\nCOMPUTING", image: Embeded },
      { title: "WEB\nSCRAPING", image: ScrapingSvg },
    ]
];

// INDUSTRIES SECTION
export const industries = [
  { id: 1, 
    title: "Real Estate",
    icons: estate,
    items: ["Create architectural models", "Interior design apps", "Decorating apps", "3D house tours"]
  },
  { id: 2, 
    title: "Ecommerce & retail", 
    icons: ecommerce,
    items: ["In-store navigation", "Virtual fitting rooms", "AR shop assistants", "Virtual try-ons", "Beacon navigation", "Product simulators"]
  },
  { id: 3, 
    title: "Healthcare", 
    icons: health,
    items: ["Doctor consultation", "Surgery assistance", "Training simulation", "Augmented diagnosis", "Pain relief", "Health treatments"]
  },
  { id: 4, 
    title: "Manufacturing", 
    icons: manufacturing,
    items: ["Equipment installation", "Design and engineering", "Diagnostics and repair", "Safety training", "Automated quality assurance"]
  },
  { id: 5, 
    title: "Media & Entertainment", 
    icons: media,
    items: ["Augmented broadcast", "AR/VR events", "AR/VR Experiences", "3D films", "Trade show displays"]
  },
  { id: 6, 
    title: "Tourism & Travel", 
    icons: tourism,
    items: ["Virtual visits", "Navigation", "Local experiences", "Sightseeing tips", "AR/VR museums"]
  },
  {
    id: 7,
    title: "Education & training",
    icons: education,
    items: ["On-line learning", "Immersive learning", "Virtual onboarding"]
  },
  {
    id: 8,
    title: "Gaming",
    icons: gaming,
    items: ["AR/VR Gaming", "Creative content", "Real-time interaction", "3D gaming"]
  }
];

// PROCESS STEPS SECTION
export const processStep = [
  { id: 1, 
    title1: "Analysis & Planning", 
    title2: "Planning", 
    content: "Analysis & Planning." 
  },
  { id: 2, 
    title1: "Estimate Complexity & Design Solution", 
    title2: "& Design Solution", 
    content: "Estimate Complexity & Design Solution." 
  },
  { id: 3, 
    title1: "Project Proposal", 
    content: "Project Proposal." 
  },
  { id: 4, 
    title1: "Assigning an Expert Team", 
    title2: "Expert Team", 
    content: "Assigning an Expert Team." 
  },
  { id: 5, 
    title1: "Development", 
    content: "Development." },
  { id: 6, 
    title1: "Delivery & Support", 
    title2: "& Support", 
    content: "Delivery & Support." 
  }
];

// SERVICES SECTION
export const textData = [
  {
    id: 1,
    text: 'We are very knowledgeable of the mechanisms and workings of securities markets, exchanges (both centralized and decentralized), and market data (both time & sales and full order book).',
    className: 'p-one'
  },
  {
    id: 2,
    text: 'We are experienced working with - and coding against - trading APIs/ABIs and other common elements of the client/message server architectures typically seen in trading systems.',
    className: 'p-two'
  },
  {
    id: 3,
    text: 'We are specialists in implementations of QuickFIX, the open source implementation of the FIX messaging protocol',
    className: 'p-three'
  }
   
];

// BLOGS DATA SECTION
export const blogsData = [
  {
    id: 1,
    title: "At vero eos et accusamus et iusto odio",
    subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "Dec 12, 2022",
    link: "blockchain",
    image: blog1 
  },
  {
    id: 2,
    title: "At vero eos et accusamus et iusto odio",
    subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "Jan 10, 2023",
    link: "crypto",
    image: blog2 
  },
  {
    id: 3,
    title: "At vero eos et accusamus et iusto odio",
    subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "Feb 20, 2023",
    link: "binance",
    image: blog3
  },
  {
    id: 4,
    title: "At vero eos et accusamus et iusto odio",
    subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "Mar 15, 2023",
    link: "chain",
    image: blog4
  },
  {
    id: 5,
    title: "At vero eos et accusamus et iusto odio",
    subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "Apr 22, 2023",
    link: "stock",
    image: blog5
  },
  {
    id: 6,
    title: "At vero eos et accusamus et iusto odio",
    subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    date: "May 30, 2023",
    link: "trust",
    image: blog6 
  }
];

// FAQS SECTION
export const faqs = [
  {
    id: 1,
    question: "Industrial IoT",
    icons: industrialIcon,
    answer: "It combines the value of data analytics and connected equipment. These solutions will allow you to automate production, maintenance and other key processes for your business."
  },
  {
    id: 2,
    question: "Heathcare IoT",
    icons: healthcareIcon,
    answer: "We provide solutions for consumer, hospital personnel and in-hospital use for data collection and analysis. Our solutions enhance patients’s healthcare experience and optimize workflow of healthcare facilities."
  },
  {
    id: 3,
    question: "Retail IoT",
    icons: retailIcon,
    answer: "IoT can enhance customer experience and optimize supply chain operations. IoT can be applied to inventory management, proximity marketing solutions, automated delivery vehicles and IoT powered retail data analytics systems."
  },
  {
    id: 4,
    question: "Agricultural IoT",
    icons: agriculturalIcon,
    answer: "IoT enables farmers and growers to reduce waste and increase productivity. IoT can be applied to monitor crops remotely, analyze soil automatically, livestock tracking and geofencing, use drones for irrigation, smart greenhouses and much more."
  }
];

// APPROACH
export const approachData = [
  {
    id: 1,
    title: 'IoT application',
    subtitle: 'design',
    description: 'We listen, analyze functional and non-functional requirements of your IoT project, select applicable use cases and create a proof of concept (POC).'
  },
  {
    id: 2,
    title: 'MVP',
    subtitle: ' development',
    description: 'We set up an expert IoT development team and create a minimum viable product (MVP) to test your business assumptions at record time and with a minimal cost.'
  },
  {
    id: 3,
    title: 'MVP rollout, testing',
    subtitle: 'and scaling',
    description: 'We deploy your IoT solution, test it on real-world data and tasks and collect user feedback to further improve the system. We iteratively add new features and use cases.'
  },
  {
    id: 4,
    title: 'Data',
    subtitle: 'Analytics',
    description: 'We develop structured data analytic tools and dashboards to convert your unstructured IoT data into actionable business insights that enable strategic decision making.'
  },
  {
    id: 5,
    title: 'Third party',
    subtitle: 'integration',
    description: 'We integrate you IoT solution into your current IT infrastructure, and validate your system does not contain security vulnerabilities.'
  }
];

// ACCORDION DATA SECTION
export const accordionData = [
    {
      id: 1,
      title: "Machine Learning",
      icon: require("./svgs/Group 1000001130.svg"),
      content: "Our team of machine learning specialists will help your business realize new growth opportunities. We have developed solutions for a wide variety of industries and sectors ranging from healthcare, fintech, agriculture, logistics, retail, sports, hospitality and more."
    },
    {
      id: 2,
      title: "Computer Vision",
      icon: require("./svgs/computer-svg.svg"),
      content: "We empower your business with tech solutions from ideation to completion. We are proficient in tasks such as object detection, object tracking, classification and segmentation. We can help with integration and customization of computer vision solutions according to your needs."
    },
    {
      id: 3,
      title: "Natural Language Processing",
      icon: require("./svgs/processing-svg.svg"),
      content: "We provide expert-level knowledge in NLP-related tasks including entity recognition, sentiment analysis, semantic vector embeddings (e.g., word2vec, doc2vec, sense2vec), automatic text categorization and chatbot development."
    },
    {
      id: 4,
      title: "Chatbots",
      icon: require("./svgs/chatbot-svg.svg"),
      content: "We specialize in developing advanced chatbot solutions designed to enhance customer interactions and streamline business operations. Leveraging cutting-edge artificial intelligence and natural language processing technologies."
    },
    {
      id: 5,
      title: "Time Series Prediction",
      icon: require("./svgs/time-svg.svg"),
      content: "We specialize in leveraging advanced time series prediction models to forecast future trends and behaviors based on historical data."
    },
    {
      id: 6,
      title: "Data Analytics",
      icon: require("./svgs/data analytics-svg.svg"),
      content: "We excel in harnessing the power of data to provide actionable insights and strategic guidance to businesses. Their expertise lies in collecting, analyzing, and interpreting large volumes of data from diverse sources."
    }
];

export const technologies = [
  {
    title: "LOW LEVEL",
    content: `

      RTLinux, RIOT, FreeRTOS, VxWorks, Windows IoT, Android Things, embOS, ThreadX, Nucleus RTOS
    `
  },
  {
    title: "CONNECTIVITY AND MIDDLEWARE",
    content: `
      MQTT, CoAP, REST, AMQP, WebSocket, TCP/IP, Bluetooth, BLE, WiFi, GPRS, NFC, Zigbee, CAN/CANOpen, Beacon, Z-Wave, HTTP/HTTPS, XMPP
    `
  },
  {
    title: "PROCESSING",
    content: `
      Amazon Web Services, IBM Watson IoT platform, Microsoft Azure IoT Hub, Google Cloud IoT, Oracle IoT Cloud Service, SAP IoT Platform, Cisco IoT
    `
  },
  {
    title: "APPS UI",
    content: `
      Java, .NET, Qt, PHP, Python, Objective-C, Swift, Go, Rust, Node.js, React
    `
  }
];

// ROBOTICS SECTION
export const robotic = [
  {
    id: 1,
    category: "Robot Operating System (ROS)",
    items: [
      { id: 'ros1', text: "Navigation stack" },
      { id: 'ros2', text: "Localization stack" },
      { id: 'ros3', text: "ros_control cartographer" },
      { id: 'ros4', text: "slam_toolbox, AMCL" },
      { id: 'ros5', text: "Deploying ROS on custom robotic solutions" },
      { id: 'ros6', text: "Developing drivers for sensors and actuators" },
    ],
  },
  {
    id: 2,
    category: "Drones",
    items: [
      { id: 'drone1', text: "Px4 flight stack" },
      { id: 'drone2', text: "ArduPilot (ArduCopter, ArduRover)" },
      { id: 'drone3', text: "Developing drivers for custom sensors for the above flight stacks" },
      { id: 'drone4', text: "Using ROS on a companion computer for high level control" },
    ],
  },
  {
    id: 3,
    category: "Sensors",
    items: [
      { id: 'sensor1', text: "ToF sensors (single points and arrays)" },
      { id: 'sensor2', text: "Ultra Wide Band (UWB) localization" },
      { id: 'sensor3', text: "RTK GPS" },
      { id: 'sensor4', text: "Single and multiple LiDARs (Hokuyo, RPLIDAR, Livox, Ouster OS-1)" },
      { id: 'sensor5', text: "IMUs (RazorIMU, Bosch BNO055, PhidgetsSpatial, Xsens)" },
      { id: 'sensor6', text: "Tracking modules (Realsense T265)" },
      { id: 'sensor7', text: "3D Cameras (Realsense D435)" },
    ],
  },
  {
    id: 4,
    category: "Other",
    items: [
      { id: 'other1', text: "Raspberry pi (4, 3, 3B+)" },
      { id: 'other2', text: "Arduino UNO, Mega, Nano" },
    ],
  },
];

// LEVERAGES SECTION
export const leverages = [
  {
    id: 1,
    title: "Blockchain consulting",
    description: "Our expert developers will analyze your goals and needs and help you define blockchain technology solutions tailored to address your specific use cases and scenarios.",
    icon: BlockChainSvg
  },
  {
    id: 2,
    title: "Non-fungible tokens (NFTs)",
    description: "We help businesses create, manage, and trade non-fungible tokens (NFTs) with robust smart contract solutions to ensure immutability, provenance, and ownership.",
    icon: fungible
  },
  {
    id: 3,
    title: "dApps",
    description: "With our expertise in decentralized applications, our blockchain developers can help you build dApps that provide transparency, security, and reliability on blockchain networks.",
    icon:  dApps
  },
  {
    id: 4,
    title: "Metaverse",
    description: "With our focus on blockchain, NFTs, and crypto development, we can help you build and integrate blockchain-based features in existing and emerging metaverse ecosystems.",
    icon: meta
  },
  {
    id: 5,
    title: "Custom Blockchain App Development",
    description: "We build custom blockchain applications tailored to your business needs, ensuring they are highly secure, scalable, and interoperable.",
    icon: custom
  },
  {
    id: 6,
    title: "Smart Contracts",
    description: "Our smart contract development services include designing, developing, auditing, and optimizing smart contracts for various blockchain platforms.",
    icon: smart
  },
  {
    id: 7,
    title: "Centralized / Decentralized Exchange",
    description: "We offer comprehensive solutions for developing and deploying centralized and decentralized exchange platforms for secure and efficient trading of cryptocurrencies.",
    icon: exchange
  },
  {
    id: 8,
    title: "Blockchain Wallet",
    description: "Our team can develop secure and user-friendly blockchain wallets for storing, managing, and transferring cryptocurrencies, ensuring a seamless user experience.",
    icon: wallet
  },
  {
    id: 9,
    title: "Tokenization",
    description: "Our blockchain developers can help you create and manage tokenization strategies for real-world assets, ensuring liquidity and security for investors.",
    icon: token
  }
];

// COVERS SECTION 
export const covers = [
  { id: 1, title: "Airdrop Contracts" },
  { id: 2, title: "Binance Smart Chain" },
  { id: 3, title: "Bitcoin" },
  { id: 4, title: "Blockchain Explorer" },
  { id: 5, title: "BSC" },
  { id: 6, title: "BTC" },
  { id: 7, title: "Consensus" },
  { id: 8, title: "Cryptocurrency" },
  { id: 9, title: "Custom Sale Contracts" },
  { id: 10, title: "Dapp" },
  { id: 11, title: "Defi" },
  { id: 12, title: "Encryption" },
  { id: 13, title: "Erc20" },
  { id: 14, title: "Erc223" },
  { id: 15, title: "Erc721" },
  { id: 16, title: "Erc865" },
  { id: 17, title: "Escrow Contracts" },
  { id: 18, title: "ETH" },
  { id: 19, title: "Ethereum" },
  { id: 20, title: "Exchanges" },
  { id: 21, title: "Fintech" },
  { id: 22, title: "Forks" },
  { id: 23, title: "Gasless Contracts TronLink Integration" },
  { id: 24, title: "Hyperledger" },
  { id: 25, title: "Level-0" },
  { id: 26, title: "Litecoin" },
  { id: 27, title: "Market Places" },
  { id: 28, title: "Metamask" },
  { id: 29, title: "Mining" },
  { id: 30, title: "Mining" },
  { id: 31, title: "NFTs" },
  { id: 32, title: "Node Setup" },
  { id: 33, title: "PlayToEarn" },
  { id: 34, title: "Ripple" },
  { id: 35, title: "Rust" },
  { id: 36, title: "Smart Contracts" },
  { id: 37, title: "Solana" },
  { id: 38, title: "Solidity" },
  { id: 39, title: "Staking Contracts" },
  { id: 40, title: "Stellar" },
  { id: 41, title: "Swapping Contracts" },
  { id: 42, title: "Tokens" },
  { id: 43, title: "Trading Bots" },
  { id: 44, title: "Tron" },
  { id: 45, title: "TronWeb" },
  { id: 46, title: "Ve Chain" },
  { id: 47, title: "Wallets" },
  { id: 48, title: "Web3" },
  { id: 49, title: "Whitepaper" },
];

// XR SECTION
export const xrService = [
  {
    id: 1,
    title: "Virtual Reality",
    description: "Take your business to the next level with our virtual reality solutions applicable to any industry.",
    icon: vr
  },
  {
    id: 2,
    title: "Augmented Reality",
    description: "Make your products more attractive by creating new real-world environments with computer-generated visual content.",
    icon: ar
  },
  {
    id: 3,
    title: "3D Modeling",
    description: "3D modeling services will give you powerful visual aids to support your marketing efforts.",
    icon: model
  }
];




